// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BotProfile__container-aa6e1e {
  --padding: 24px;
}

.BotProfile__header-dd5b01 {
  display: flex;
  padding-bottom: 12px;
  padding-inline-start: var(--padding);
}

.BotProfile__avatar-e14527 {
  display: flex;
  align-items: flex-start;
  margin-inline-end: 16px;
}

.BotProfile__info-a4f807 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
}

.BotProfile__title-ac115b {
  font: var(--font-title-8);
  letter-spacing: var(--font-spacing-title-9);
  color: var(--base-110);
  word-break: break-all;
}

.BotProfile__subtitle-c19c9e {
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-80);
  margin-top: 4px;
}

.BotProfile__actions-b3f054 {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 4px 24px 16px;
}

.BotProfile__action-button-b8333d {
  margin-inline-start: 16px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.BotProfile__action-button-icon-f22220 {
  display: flex;
  align-items: center;
}

.BotProfile__contact-dd66a9 {
  padding: 8px var(--padding);
}

.BotProfile__list-item-f136dc {
  min-height: 48px;
  padding: 0 var(--padding);
}

.BotProfile__list-icon-d878b8 {
  fill: var(--base-80);
}`, "",{"version":3,"sources":["webpack://./src/main/Profile/BotProfile/BotProfile.styles.m.css"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,aAAA;EACA,oBAAA;EACA,oCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,qBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;AACF","sourcesContent":[".container {\n  --padding: 24px;\n}\n\n.header {\n  display: flex;\n  padding-bottom: 12px;\n  padding-inline-start: var(--padding);\n}\n\n.avatar {\n  display: flex;\n  align-items: flex-start;\n  margin-inline-end: 16px;\n}\n\n.info {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.title {\n  font: var(--font-title-8);\n  letter-spacing: var(--font-spacing-title-9);\n  color: var(--base-110);\n  word-break: break-all;\n}\n\n.subtitle {\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-80);\n  margin-top: 4px;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n  padding: 4px 24px 16px;\n}\n\n.action-button {\n  margin-inline-start: 16px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n}\n\n.action-button-icon {\n  display: flex;\n  align-items: center;\n}\n\n.contact {\n  padding: 8px var(--padding);\n}\n\n.list-item {\n  min-height: 48px;\n  padding: 0 var(--padding);\n}\n\n.list-icon {\n  fill: var(--base-80);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BotProfile__container-aa6e1e`,
	"header": `BotProfile__header-dd5b01`,
	"avatar": `BotProfile__avatar-e14527`,
	"info": `BotProfile__info-a4f807`,
	"title": `BotProfile__title-ac115b`,
	"subtitle": `BotProfile__subtitle-c19c9e`,
	"actions": `BotProfile__actions-b3f054`,
	"action-button": `BotProfile__action-button-b8333d`,
	"actionButton": `BotProfile__action-button-b8333d`,
	"action-button-icon": `BotProfile__action-button-icon-f22220`,
	"actionButtonIcon": `BotProfile__action-button-icon-f22220`,
	"contact": `BotProfile__contact-dd66a9`,
	"list-item": `BotProfile__list-item-f136dc`,
	"listItem": `BotProfile__list-item-f136dc`,
	"list-icon": `BotProfile__list-icon-d878b8`,
	"listIcon": `BotProfile__list-icon-d878b8`
};
module.exports = ___CSS_LOADER_EXPORT___;
